import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Card, Spinner, Table, Alert, Form, Button } from "react-bootstrap";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";

const Attendance = () => {
    const { userId } = useContext(ProductContext);
    const authtoken = localStorage.getItem("token");

    const [studentId, setStudentId] = useState(null);
    const [attendanceData, setAttendanceData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchStudentId = async () => {
            const cacheKey = `transport_stud_${userId}`;
            const cached = getCachedData(cacheKey);
            if (cached) {
                setStudentId(cached);
            }
            try {
                const response = await fetch(`https://api.mirai.healthcare/api/student?regs_id=${userId}`, {
                    headers: { "x-auth": `${authtoken}` },
                });
                const data = await response.json();
                if (data.success && data.message.length > 0) {
                    const studentData = data.message[0];
                    setStudentId(studentData.id);
                    setCachedData(cacheKey, studentData.id);
                }
            } catch (err) {
                console.error("Error fetching student ID:", err);
            }
        };
        fetchStudentId();
    }, [userId, authtoken]);

    useEffect(() => {
        if (!studentId) return;

        const fetchAttendanceData = async () => {
            if (!studentId) return;
            const cacheKey = `transport_attendance_${studentId}`;
            const cached = getCachedData(cacheKey);
            if (cached) {
                setAttendanceData(cached);
                setLoading(false);
            }
            if (!cached) setLoading(true);
            try {
                const response = await fetch(
                    `https://api.mirai.healthcare/api/attendance/StudentAttendance/daily?student_id=${studentId}`,
                    {
                        headers: { "x-auth": `${authtoken}` },
                    }
                );
                const data = await response.json();
                if (data.success) {
                    setAttendanceData(data.data || []);
                    setCachedData(cacheKey, data.data || []);
                }
            } catch (err) {
                console.error("Error fetching attendance data:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchAttendanceData();
    }, [studentId, authtoken]);

    return (
        <div className="page-wrapper">
            <Header />
            <Container className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2>📅 Student Daily Attendance</h2>
                </div>

                {loading ? (
                    <div className="text-center">
                        <Spinner animation="border" />
                    </div>
                ) : attendanceData.length > 0 ? (
                    <Card className="shadow-sm">
                        <Card.Body>
                            <h5 className="mb-3">🗓️ Attendance Records</h5>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Status</th>
                                        <th>Leave Type</th>
                                        <th>Transport Opted</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attendanceData.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.date}</td>
                                            <td className={item.status === "present" ? "text-success" : "text-danger"}>
                                                {item.status.toUpperCase()}
                                            </td>
                                            <td>{item.leave_type || "N/A"}</td>
                                            <td>{item.is_transport_opted ? "Yes" : "No"}</td>
                                            <td>{item.notes || "N/A"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                ) : (
                    <Alert variant="info">No attendance records found.</Alert>
                )}
            </Container>
        </div>
    );
};

export default Attendance;
